var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { debounce } from "lodash";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import { Input } from "./";
var PriceInput = /** @class */ (function (_super) {
    __extends(PriceInput, _super);
    function PriceInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (value) {
            if (value && Number(value) > 0) {
                _this.props.onChange(value);
            }
        };
        _this.onBlur = function (value) {
            var price = Number.parseFloat(value).toFixed(2);
            if (price && Number(price) > 0) {
                _this.props.onChange(price);
            }
        };
        _this.onChange = debounce(_this.onChange, 200);
        return _this;
    }
    PriceInput.prototype.render = function () {
        var _a = this.props, currency = _a.currency, id = _a.id, label = _a.label, min = _a.min, name = _a.name, step = _a.step, value = _a.value, validation = _a.validation;
        return (React.createElement(Input, { addon: { before: formatCurrency({ currencyCode: currency }) }, id: id, label: label, min: min, name: name, onBlur: this.onBlur, onChange: this.onChange, step: step, type: "number", value: value, validation: validation }));
    };
    return PriceInput;
}(Component));
export default PriceInput;
